export default "__VITE_ASSET__e8GsdvHo__"